// extracted by mini-css-extract-plugin
export var aButton1 = "Vg";
export var aButton2 = "Wg";
export var aButton3 = "Xg";
export var aButton4 = "Yg";
export var aButton5 = "Zg";
export var aButtonHeaderLogin = "_g";
export var aButtonHeaderRegister = "ah";
export var aButtonBig = "bh";
export var aButtonRegister = "ch";
export var aButtonLogin = "dh";
export var aButtonContinuation = "eh";
export var icon = "fh";
export var aButtonHeaderSpLogin = "gh";
export var pFooterMenu = "hh";
export var lFooter = "ih";
export var lFooter__inner = "jh";
export var lFooter__logo = "kh";
export var lFooter__copyright = "lh";
export var animationMarquee = "mh";